import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ButtonWithIcon from "components/sales/buttons/buttonWithIcon/buttonWithIcon";
import Input from "components/sales/Input/input";
import Loader from "components/sales/Loader/loader";
 import './loginOtp.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { GoogleLogin, GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { gapi } from 'gapi-script';
import { toast } from 'react-toastify';


const LoginOtp = ({ tryGoogleAuthorisedUserLogin,location, history, userLogin, generateOtp,login_data = [] }) => {
  const [isError, setIserror] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [email,setEmail] = useState(null);
  const [roleId,setRoleId] = useState(null);
  const [clientId,setclientId] = useState('562755967467-9ivc9vp6n8a33u0r1dknbp5patbfes98.apps.googleusercontent.com')

  useEffect(() => {
    setEmail(location.state?.email ? location.state?.email : null)
    if (
      location.state === undefined ||
      location.state === null ||
      location.state?.email === ""
    ) {
      history.push("/");
    }
  }, []);
  const firstInputRef = useRef(null);
  const secondInputRef = useRef(null);
  const thridInputRef = useRef(null);
  const fourthInputRef = useRef(null);
  let count = 0;

  useEffect(() => {
    firstInputRef.current.focus();
  }, [firstInputRef]);

  const handleChange = (val, index) => {
    if (val !== "") {
      if (index === 0 && firstInputRef.current.value.length) {
        secondInputRef.current.focus();
      } else if (index === 1 && secondInputRef.current.value.length) {
        thridInputRef.current.focus();
      } else if (index === 2 && thridInputRef.current.value.length) {
        fourthInputRef.current.focus();
      }
    }
  };

  const resendOtp = async () => {
    if(email !== null) {
      setIsLoading(true);
    const res = await generateOtp(email, true);
    setIsLoading(false);
    if (res === true) {
      setResendSuccess(true);
      setTimeout(() => setResendSuccess(false), 5000)
    }
    }
    
  };

  const handleKeyPress = (keyCode, index) => {
    if (keyCode === 8) {
      count++;
      if (index === 3 && fourthInputRef.current.value === "" && count === 2) {
        thridInputRef.current.focus();
        count = 0;
      } else if (
        index === 2 &&
        thridInputRef.current.value === "" &&
        count === 2
      ) {
        secondInputRef.current.focus();
        count = 0;
      } else if (
        (index === 1 && secondInputRef.current.value === "" && count === 2,
        index === 0 && firstInputRef.current.value === "" && count === 2)
      ) {
        firstInputRef.current.focus();
        count = 0;
      }
    }
  };

  const handleSubmit = async () => {
    const inputValues = [
      firstInputRef.current.value,
      secondInputRef.current.value,
      thridInputRef.current.value,
      fourthInputRef.current.value,
    ];
    if (email !== null && roleId != null) {
      const otp = inputValues.join("");
      if (otp.length === 4 && /^\d{4}$/.test(otp)) {
        setIserror(false);
        setIsLoading(true);
        const response = await userLogin(email, otp, roleId);
        
        // console.log(response); return false;
        setIsLoading(false);
        if (response?.status === true) {
          window.scrollTo(0, 0);
          console.log(localStorage.getItem('authenticated'))
          // history.push("/dashboard");
          setTimeout(() => {
            console.log('session start');
            
            
          }, 1000);
          // return false;
          // window.location.reload("/dashboard/pm-dashboard");
          window.location.href="/dashboard/pm-dashboard";
          // history.push("/dashboard/pm-dashboard");
        }
      } else {
        firstInputRef.current.value = "";
        secondInputRef.current.value = "";
        thridInputRef.current.value = "";
        fourthInputRef.current.value = "";
        firstInputRef.current.focus();
        setIserror(true);
      }
    }
  };

  const handleGoogleAuthorisedUser = async (data) => {
    if(data) {
      setIsLoading(true);
      const response = await tryGoogleAuthorisedUserLogin(data);
      setIsLoading(false);
      if (response?.status === true) {
        window.scrollTo(0, 0);
        console.log(localStorage.getItem('authenticated'))
        setTimeout(() => {
          console.log('session start');
        }, 1000);
        window.location.href="/dashboard/pm-dashboard";
      }
    }
  }

  useEffect(() => {
    if(gapi.client !== undefined){
    const initClient = () => {
          gapi.client.init({
          clientId: clientId,
          scope: ''
        });
     };
     gapi.load('client:auth2', initClient);       
    }
  },[]);

  const onSuccess = (codeResponse) => {
    console.log('success:', codeResponse);
    var data = {
      'google_token': codeResponse.credential
    }
    if(data) {
      handleGoogleAuthorisedUser(data); 
    }
  };
  const onFailure = (err) => {
    console.log('failed:', err);
    toast.error('Authentication Failed...');
  };

  return (
    <div className="login-box">
      <div className="login-logo">
        <img src={Images?.Logo} alt="" />
        <span>{localization.fusion}</span>
      </div>
      <div className="login-container">
        <Loader isLoading={isLoading} />
        <div className="login-fieldset">
          <h4>{localization.loginToAccount}</h4>
          <p>{localization.sentOtp}</p>
          {console.log(login_data)}
         
          <div className="form-group form-align" >
          {login_data.length !== 0 ? 
            <DropDownInput
            disabled={login_data.length === 0}
            label={`Select Role`}
            data={login_data}
            getIdValue={(val) => {
              setRoleId( val.id)
            }}
          />
            : ''}
            <div className="otp-group">
              {[
                firstInputRef,
                secondInputRef,
                thridInputRef,
                fourthInputRef,
              ].map((item, index) => {
                return (
                  <div className="otp-field" key={index}>
                    <Input
                      type="tel"
                      ref={item}
                      handleKeyPress={handleKeyPress}
                      handleChange={handleChange}
                      index={index}
                    />
                  </div>
                );
              })}
            </div>
            <label className="msg">
              {localization.OtpNotRec}{" "}
              <Link
                to="#"
                onClick={() => {
                  resendOtp();
                }}
              >
                {localization.resend}
              </Link>
            </label>
            <div className="d-flex flex-column w-100 justify-content-center align-items-center">
              <label className={` error ${isError ? "d-block" : ""}  `}>
                {localization.enterOtp}
              </label>
            </div>
            <div className="d-flex flex-column w-100 justify-content-center align-items-center">
              <label className={` error ${resendSuccess ? "d-block" : ""}  `}>
                {localization.otpResndMsg}
              </label>
            </div>
          </div>
          <div className="form-group form-group_N">
            <b  className="form-N-btn">
            <ButtonWithIcon
              title="Log In"
              type="button"
              src={Images?.ArrowRight}
              onClick={handleSubmit}
            />
            </b>
             {/* <b className="New-form">
              <GoogleOAuthProvider clientId="562755967467-9ivc9vp6n8a33u0r1dknbp5patbfes98.apps.googleusercontent.com">
              <GoogleLogin
                  clientId={clientId}
                  buttonText="Log in with Google"
                  onSuccess={onSuccess}
                  onFailure={onFailure}
                  cookiePolicy={'single_host_origin'}
                  isSignedIn={true}
              />
              </GoogleOAuthProvider>
              </b> */}
          </div>
        </div>
      </div>
      <div className="copyright">
        <p>{localization.copyRight}</p>
      </div>
    </div>
  );
};

export default LoginOtp;
